import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/",
      name: "login",
      isLayout: false, //是否渲染再首页侧边栏
      meta: {
        title: "登录",
      },
      component: () => import("@/view/login.vue"),
    },
    /*{
      path: "/layout/home",
      name: "home",
      isLayout: false, //是否渲染再首页侧边栏
      meta: {
        title: "首页",
      },
      component: () => import("@/view/layout/home.vue"),
    },*/
    /*{
      path: "/printSys",
      name: "printSys",
      isLayout: false, //是否渲染再首页侧边栏
      meta: {
        title: "打印机设置",
      },
      component: () => import("@/view/printSys.vue"),
    },*/
    {
      path: "/layout",
      name: "layout",
      isLayout: true,
      meta: {
        title: "首页",
      },
      component: () => import("@/view/index.vue"),
      children: [
        {
          nameText: "首页",
          parent: "Home",
          parentName: "首页",
          path: "Home",
          name:'Home',
          component: () => import("@/view/layout/Home.vue")
        },
        {
          nameText: "水费收取",
          parent: "MechanicalWaterMeter", //机械水表缴费
          parentName: "机械水表缴费", //机械水表缴费
          path: "WaterChargeCollection",
          name:'WaterChargeCollection',
          component: () => import("@/view/layout/WaterChargeCollection.vue"),
        },
        {
          nameText: "收据管理",
          parent: "MechanicalWaterMeter", //机械水表缴费
          parentName: "机械水表缴费", //机械水表缴费
          path: "WaterBillManagement",
          name:'WaterBillManagement',
          component: () => import("@/view/layout/WaterBillManagement.vue"),
        },
        {
          nameText: "收费查询",
          parent: "MechanicalWaterMeter", //机械水表缴费
          parentName: "机械水表缴费", //机械水表缴费
          path: "WaterBillinquiry",
          name:'WaterBillinquiry',
          component: () => import("../view/layout/WaterBillinquiry.vue"),
        },
        {
          nameText: "回收金额",
          parent: "MechanicalWaterMeter", //机械水表缴费
          parentName: "机械水表缴费", //机械水表缴费
          path: "WaterRecovery",
          name:'WaterRecovery',
          component: () => import("../view/layout/WaterRecovery.vue"),
        },
        {
          nameText: "电费收取",
          parent: "MechanicalElectricityMeter", //机械电表缴费
          parentName: "机械电表缴费", //机械水表缴费
          path: "ElectricityCharge",
          name:'ElectricityCharge',
          component: () => import("../view/layout/ElectricityCharge.vue"),
        },
        {
          nameText: "收据管理",
          parent: "MechanicalElectricityMeter", //机械电表缴费
          parentName: "机械电表缴费", //机械电表缴费
          path: "ElectricityBillManagement",
          name:'ElectricityBillManagement',
          component: () => import("../view/layout/ElectricityBill.vue"),
        },
        {
          nameText: "收费查询",
          parent: "MechanicalElectricityMeter", //机械电表缴费
          parentName: "机械电表缴费", //机械电表缴费
          path: "ElectricityChargeSearch",
          name:'ElectricityChargeSearch',
          component: () => import("../view/layout/ElectricityChargeSearch.vue"),
        },
        {
          nameText: "回收金额",
          parent: "MechanicalElectricityMeter", //机械电表缴费
          parentName: "机械电表缴费", //机械电表缴费
          path: "ElectricityRecovery",
          name:'ElectricityRecovery',
          component: () => import("../view/layout/ElectricityRecovery.vue"),
        },
        {
          nameText: "IC卡设置",
          parent: "IC", //机械电表缴费
          parentName: "IC卡表充值管理", //机械水表缴费
          path: "ICCardSetting",
          name:'ICCardSetting',
          component: () => import("../view/layout/ICCardSetting.vue"),
        },
        {
          nameText: "用户开卡",
          parent: "IC", //机械电表缴费
          parentName: "IC卡表充值管理", //机械水表缴费
          path: "ICUserCardOpening",
          name:'ICUserCardOpening',
          component: () => import("../view/layout/ICUserCardOpening.vue"),
        },
        {
          nameText: "IC卡充值",
          parent: "IC", //机械电表缴费
          parentName: "IC卡表充值管理", //机械水表缴费
          path: "ICCharge",
          name:'ICCharge',
          component: () => import("../view/layout/ICCharge.vue"),
        },
        {
          nameText: "收费查询",
          parent: "IC",
          parentName: "IC卡表充值管理",
          path: "ICChargeQuery",
          name:'ICChargeQuery',
          component: () => import("../view/layout/ICChargeQuery.vue"),
        },
        {
          nameText: "充值修改",
          parent: "IC",
          parentName: "IC卡表充值管理",
          path: "ICRechargeModification",
          name:'ICRechargeModification',
          component: () => import("../view/layout/ICRechargeModification.vue"),
        },
        {
          nameText: "水表换表",
          parent: "IC",
          parentName: "IC卡表充值管理",
          path: "ICWaterMeterReplacement",
          name:'ICWaterMeterReplacement',
          component: () => import("../view/layout/ICWaterMeterReplacement.vue"),
        },
        {
          nameText: "收据管理",
          parent: "IC",
          parentName: "IC卡表充值管理",
          path: "ICNoteManagement",
          name:'ICNoteManagement',
          component: () => import("../view/layout/ICNoteManagement.vue"),
        },
        {
          nameText: "用户管理",
          parent: "IC",
          parentName: "IC卡表充值管理",
          path: "ICUserManagement",
          name:'ICUserManagement',
          component: () => import("../view/layout/ICUserManagement.vue"),
        },
        {
          nameText: "打印机设置",
          parent: "IC",
          parentName: "IC卡表充值管理",
          path: "printSys",
          name:'printSys',
          component: () => import("../view/printSys.vue"),
        },
        {
          nameText: "处理费收取",
          parent:"Rubbish",
          parentName: "垃圾处理费",
          path: "RubbishCharge",
          name: 'RubbishCharge',
          component: () => import("../view/layout/RubbishCharge.vue"),
      },
      {
        nameText: "票据管理",
        parent:"Rubbish",
        parentName: "垃圾处理费",
          path: "RubbishChargeSearch",
          name: 'RubbishChargeSearch',
          component: () => import("../view/layout/RubbishChargeSearch.vue"),
      },
      {
        nameText: "收费查询",
        parent:"Rubbish",
        parentName: "垃圾处理费",
          path: "RubbishManagement",
          name: 'RubbishManagement',
          component: () => import("../view/layout/RubbishManagement.vue"),
      },
      ],
    },
  ]
});

router.beforeEach((to, from, next) => {
 
  if(to.name === 'printSys'){
    next();
  }else{
    if(to.name !== 'login'){
      if(sessionStorage.getItem('token')){
        next();
      }else{
        next('/');
      }
    }else{
      sessionStorage.clear();
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js